import { Autocomplete, Box, CircularProgress, TextField, Typography } from "@mui/material"
import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { searchPatients } from "../../apis/patientSlice";

const SearchPatient = ({ open, setData, data , size}) => {
    const dispatch = useDispatch();


    const [patientOptions, setPatientOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);

    const patientFetchOptions = useMemo(
        () =>
            _.debounce(async (query) => {
                setLoading(true);
                try {
                    const response = await dispatch(
                        searchPatients({ search: query })
                    );

                    setPatientOptions(
                        response &&
                        response.payload &&
                        response.payload.data.map((item) => ({
                            label: item.name,
                            value: item._id,
                            _id: item._id,
                            name: item.name,
                            email: item.email,
                            phone: item.phone,
                            address: item.address,
                            age: item.age,
                        }))
                    );
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setLoading(false);
                }
            }, 1000),
        []
    );

    useEffect(() => {
        if (open) {
            patientFetchOptions(inputValue);
        }
    }, [open, inputValue]);

    const handleChange = (e, newValue) => {
        if (newValue) {
            setData((prev) => ({ ...prev, patient: newValue }));
        } else {
            setData(null)
        }
    }

    return (
        <Autocomplete
            options={patientOptions}
            getOptionLabel={(option) => option?.name || option?.label || ""}
            isOptionEqualToValue={(option, value) =>
                (option?._id || option?.value) === (value?._id || value?.value)
            }
            value={data && data.patient}
            loading={loading}
            size={size || "medium"}
            name="patient"
            onChange={(e, newValue) => {
                handleChange(e, newValue);
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.15, py: 0.15 }}>
                        <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "var(--color-heading)" }}>
                            {option.name || "Unnamed Patient"}
                        </Typography>
                        <Typography sx={{ fontSize: "0.72rem", color: "var(--color-text-muted)", fontWeight: 600 }}>
                            {option.phone ? `Phone: ${option.phone}` : "Phone: -"}
                            {option.age ? `  •  Age: ${option.age}` : ""}
                        </Typography>
                    </Box>
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Select Patients"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px",
                        border: "1px solid var(--color-border-soft)",
                        boxShadow: "0 10px 28px rgba(16,52,92,0.12)",
                        "& .MuiAutocomplete-option": {
                            minHeight: 34,
                            py: 0.4,
                        },
                    },
                },
            }}
        />
    )
}

export default SearchPatient